import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FilePathCollection } from 'src/app/models/file/file-collection';
import { NotificationService } from 'src/app/services/notification.service';
import { ForecastService } from '../../forecast/forecast.service';
import * as FileSaver from 'file-saver';
import { ManualInputService } from '../../manual-input/manual-input.service';
import { GlobalConstants } from 'src/app/common/global-constants';
import { UtilsService } from 'src/app/services/utils.service';
import { DxChartComponent } from 'devextreme-angular';
import { DevTooltipCustComponent } from 'src/app/widgets';
import { Title } from '@angular/platform-browser';
import { TableParameterService } from 'src/app/services/table-parameter-service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.scss'],
    standalone: false
})
export class HistoryComponent implements OnInit {

	constructor(
		private titleService: Title,
		private forecastService: ForecastService,
		private notificationService: NotificationService,
		private manualInputService: ManualInputService,
		private tableParamService: TableParameterService,
		private _cdr: ChangeDetectorRef) { }

	topdownData: any;
	//dev express setting changes function for chart need on resize after windows size changes
	@ViewChild("forecastDevelopmentChart", { static: false }) dxForecastDevelopmentChart: DxChartComponent;

	ngOnInit() {
		this.titleService.setTitle("Forecast History");
		this.gettopdownListData();
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);
	}

	compactMode = false;
	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;
	}

	tableHeight = 500;
	switchTableHeight() {
		this.tableHeight = this.tableParamService.changeTableHeigh(this.tableHeight);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	onToolbarPreparing(evt) {
		const toolbarItems = evt.toolbarOptions.items;

		toolbarItems.unshift(
			{
				location: "before",
				template: "columnMode",
			},
			{
				location: 'before',
				template: 'heightButtonTemplate'
			}
		);
	}

	private gettopdownListData() {

		this.forecastService.GetTopdwonHistory("list", 0)
			.subscribe(data => {
				if (data != null && data.table != null) { this.topdownData = data.table; }

			}, (error) => {

				this.notificationService.error("something went wrong. please try again later.");
			});

		this.loadChartSettingData();

	}

	isChartLoaded: boolean = false;
	latestText = "Latest";
	latestSerieName = "Currnt";

	loadChartSettingCaption() {
		let data = this.chartData;
		data.table.forEach(itemCap => {
			if (this.dxForecastDevelopmentChart != null && this.dxForecastDevelopmentChart.series != null
				&& Array.isArray(this.dxForecastDevelopmentChart.series) && this.dxForecastDevelopmentChart.series.length > 0) {
				for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {

					if (this.dxForecastDevelopmentChart.series[index].valueField != null
						&& (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == itemCap.fieldName.toLowerCase()
							|| this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == itemCap.fieldName.toLowerCase())

					) {
						this.dxForecastDevelopmentChart.series[index].name = itemCap.captionName;
					}
					if (this.dxForecastDevelopmentChart.series[index].valueField != null
						&& (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase() == this.latestSerieName.toLowerCase() + itemCap.fieldName.toLowerCase()
							|| this.dxForecastDevelopmentChart.series[index].name.toLowerCase() == this.latestSerieName.toLowerCase() + itemCap.fieldName.toLowerCase())

					) {
						this.dxForecastDevelopmentChart.series[index].name = this.latestText + " " + itemCap.captionName;
					}

				}
			}

			if (itemCap.fieldName.toLowerCase() == "forecastoverviewcharttitle") {
				this.titleOverviewTitle = itemCap.captionName;
			}
		});




		if (this.dxForecastDevelopmentChart && this.dxForecastDevelopmentChart.series && Array.isArray(this.dxForecastDevelopmentChart.series)) {
			this.isChartLoaded = true;
			for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {


				if (data != null && data.table1 != null && data.table1.length > 0) {
					data.table1.forEach(settingItem => {
						if (settingItem.name.toLowerCase().includes("color")) {
							let ElementName = settingItem.name.toLowerCase();
							ElementName = ElementName.replace("color", "");
							if ((ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase()
								|| ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().replace(this.latestSerieName.toLowerCase(), "")
							) && settingItem.value != "") {
								if (this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().search('currnt') == -1) {
									this.dxForecastDevelopmentChart.series[index].color = settingItem.value;
								} else {
									this.dxForecastDevelopmentChart.series[index].color = this.ColorCodeChnage(settingItem.value);
								}
								console.log('color lop', this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase(), this.dxForecastDevelopmentChart.series[index].color, settingItem.value)
							}
						}
						if (settingItem.name.toLowerCase().includes("charttype")) {
							let ElementName = settingItem.name.toLowerCase();
							ElementName = ElementName.replace("charttype", "");
							if ((ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase()
								|| ElementName == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().replace(this.latestSerieName.toLowerCase(), ""))
								&& settingItem.value != null && settingItem.value != "") {
								let chartTypes = settingItem.value.split('-');
								if (chartTypes.length > 0) {
									this.dxForecastDevelopmentChart.series[index].type = chartTypes[0];
								}
								if (chartTypes.length > 1) {
									this.dxForecastDevelopmentChart.series[index].dashStyle = chartTypes[1];
								}
							}
						}
					});
				}

			}
		}
	}

	ColorCodeChnage(color) {
		let d = document.createElement("div");
		d.style.color = color;
		document.body.appendChild(d);
		//Color in RGB
		return this.LightenDarkenColor(this.rgb2hex(window.getComputedStyle(d).color), 90);
	}

	rgb2hex(rgb) {
		rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
		return (rgb && rgb.length === 4) ? "#" +
			("0" + parseInt(rgb[1], 10).toString(16)).slice(-2) +
			("0" + parseInt(rgb[2], 10).toString(16)).slice(-2) +
			("0" + parseInt(rgb[3], 10).toString(16)).slice(-2) : '';
	}

	LightenDarkenColor(col, amt) {
		let usePound = false;
		if (col[0] == "#") {
			col = col.slice(1);
			usePound = true;
		}
		let num = parseInt(col, 16);
		let r = (num >> 16) + amt;
		if (r > 255) r = 255;
		else if (r < 0) r = 0;
		let b = ((num >> 8) & 0x00FF) + amt;
		if (b > 255) b = 255;
		else if (b < 0) b = 0;
		let g = (num & 0x0000FF) + amt;
		if (g > 255) g = 255;
		else if (g < 0) g = 0;
		return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
	}

	chartData: any;
	loadChartSettingData() {
		this.forecastService.GetTopdwonHistory("chartSetting", 0)
			.subscribe(data => {
				this.chartData = data;
				this.loadChartData(0, "");
			}, (error) => {

				this.notificationService.error("something went wrong. please try again later.");
			});
	}

	fileDownloadData: FilePathCollection = new FilePathCollection();
	DownloadTopdownHistory(data) {

		this.forecastService.GetExportTopdownData("data", data.historyId).subscribe(resultFilename => {
			this.fileDownloadData.FileName = resultFilename.fieldName;
			this.fileDownloadData.LinkType = 1;
			this.manualInputService.DownloadFile(this.fileDownloadData).subscribe(result => {
				const blob = new Blob([result], { type: EXCEL_TYPE });
				FileSaver.saveAs(blob, this.fileDownloadData.FileName);

			}, error => {},
				() => console.info('File downloaded successfully'));

		}, err => {

			console.log(err);
		});
	}

	popupTopDownHistoryVisible: boolean = false;
	forecastDevelopmentChartSource: any = [];
	VisibleElements = [
		{ visible: false, showInLegend: false, SeriesName: 'addOn1', name: 'addOn1' },
		{ visible: false, showInLegend: false, SeriesName: 'addOn2', name: 'addOn2' },
		{ visible: false, showInLegend: false, SeriesName: 'addOn3', name: 'addOn3' },
		{ visible: false, showInLegend: false, SeriesName: 'addOn4', name: 'addOn4' },
		{ visible: false, showInLegend: false, SeriesName: 'addOn5', name: 'addOn5' },

		{ visible: false, showInLegend: false, SeriesName: 'currntAddOn1', name: 'addOn1' },
		{ visible: false, showInLegend: false, SeriesName: 'currntAddOn2', name: 'addOn2' },
		{ visible: false, showInLegend: false, SeriesName: 'currntAddOn3', name: 'addOn3' },
		{ visible: false, showInLegend: false, SeriesName: 'currntAddOn4', name: 'addOn4' },
		{ visible: false, showInLegend: false, SeriesName: 'currntAddOn5', name: 'addOn5' }
	];
	titleOverviewTitle = "Monthly";
	TopdownHistoryPerview(dataItem) {
		this.popupTopDownHistoryVisible = true;
		this.forecastDevelopmentChartSource = null;

		this.VisibleElements.forEach(element => {
			element.showInLegend = false;
			element.visible = false;
			if (element.name && dataItem.forecastElemntName
				&& element.name.toLocaleLowerCase() == dataItem.forecastElemntName.toLocaleLowerCase()) {
				element.showInLegend = true;
				element.visible = true;
			}
		});
		this.loadChartDynamicStting();

		this.loadChartData(dataItem.historyId, "");
	}

	loadChartData(historyId, addontype) {

		if (this.dxForecastDevelopmentChart) { this.dxForecastDevelopmentChart.instance.showLoadingIndicator(); }
		this.forecastService.ChartTopdownData(historyId)
			.subscribe(data => {

				this.forecastDevelopmentChartSource = data.table;
				if (this.dxForecastDevelopmentChart) { this.dxForecastDevelopmentChart.instance.hideLoadingIndicator(); }
				this.loadChartDynamicStting();

				this.onResize();
			}, (error) => {

				this.notificationService.error("something went wrong. please try again later.");
			});
	}

	//hide and show series on click
	onLegendClickMainChart(e: any) {
		const series = e.target;
		let ShowHide = false;
		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
			
		}
	}

	getMarkerPath(item) {
		return UtilsService.getlegendMarkerPathDynamic(item, 'deepdive', GlobalConstants.SvgLinSettingsCollection.defaultSettingsNew);
	}

	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "Year-Month", "", "");
	}

	//window resize function  refresh all charts
	onResize() {
		let $this=this;
		setTimeout(() => {
			if($this.dxForecastDevelopmentChart)
			$this.dxForecastDevelopmentChart.instance.refresh();
		});
	}

	topdownHistryMsg = "";
	topdownHistryFlag = -1;
	historyId: number;
	proceedingInfoPopup: boolean = false;
	TopdownHistoryUndo(item) {

		this.historyId = item.historyId;
		this.forecastService.GetTopdwonHistory("undo", item.historyId).subscribe(result => {

			if (result != null && result.table != null && result.table.length > 0) {
				this.topdownHistryMsg = result.table[0].msg;
				this.topdownHistryFlag = result.table[0].flag;
				this.proceedingInfoPopup = true;
			}
			else {
				this.notificationService.error("something went wrong. please try again later.");
				this.proceedingInfoPopup = false;
			}
		}, err => {

			console.log(err);
		});
	}

	UpdateForecastHistory(action) {

		this.proceedingInfoPopup = false;
		this.forecastService.UpdateForecastHistory(this.historyId, action).subscribe(result => {

			if (result != null && result.table != null && result.table.length > 0) {
				if (result.table[0].flag > 0) {
					this.notificationService.success(result.table[0].msg);
				} else {
					this.notificationService.error(result.table[0].msg);
				}
			}
			else {
				this.notificationService.error("something went wrong. please try again later.");
			}

		}, err => {

			console.log(err);
		});
	}

	loadChartDynamicStting() {
		console.log(this.VisibleElements);

		if (this.dxForecastDevelopmentChart && this.dxForecastDevelopmentChart.series && Array.isArray(this.dxForecastDevelopmentChart.series)) {
			for (let index = 0; index < this.dxForecastDevelopmentChart.series.length; index++) {
				//emable/disbale
				if (this.dxForecastDevelopmentChart.series[index].valueField != null) {
					console.log(this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase());
					let ElemntExists = this.VisibleElements.filter(x => x.SeriesName.toLowerCase() == this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase());
					if (ElemntExists != null && ElemntExists.length > 0) {
						if (ElemntExists.length > 1) {
							if (!ElemntExists[0].visible || !ElemntExists[1].visible) {
								this.dxForecastDevelopmentChart.series[index].visible = false;
							}
							else {
								this.dxForecastDevelopmentChart.series[index].visible = true;
							}

							if (!ElemntExists[0].showInLegend || !ElemntExists[1].showInLegend) {
								this.dxForecastDevelopmentChart.series[index].showInLegend = false;
							}
							else {
								this.dxForecastDevelopmentChart.series[index].showInLegend = true;
							}
						}
						else {
							this.dxForecastDevelopmentChart.series[index].visible = ElemntExists[0].visible;
							this.dxForecastDevelopmentChart.series[index].showInLegend = ElemntExists[0].showInLegend;
						}
					}
					else {
						if (!this.dxForecastDevelopmentChart.series[index].valueField.toLowerCase().includes("addon")) {
							this.dxForecastDevelopmentChart.series[index].visible = true;
							this.dxForecastDevelopmentChart.series[index].showInLegend = true;
						}
					}
				}
			}
		}
		this.loadChartSettingCaption();
	}

}
